<template>
    <div class="digital-classrooms-signup">
        <div class="digital-classrooms-signup__table">
            <div :class="['digital-classrooms-signup__table-row', 'digital-classrooms-signup__headers', {'--mobile' : isMobileView}]">
                <div v-if="isDesktopView" class="digital-classrooms-signup__table-cell --name" v-html="$t('DigitalClassrooms.training_name')"></div>
                <div class="digital-classrooms-signup__table-cell" v-html="$t('DigitalClassrooms.date')"></div>
                <div class="digital-classrooms-signup__table-cell" v-html="$t('DigitalClassrooms.time')"></div>
                <div class="digital-classrooms-signup__table-cell" v-html="$t('DigitalClassrooms.duration')"></div>
                <div v-if="!pastEventsTable && isDesktopView" class="digital-classrooms-signup__table-cell" v-html="$t('DigitalClassrooms.seats')"></div>
                <div v-if="isDesktopView" class="digital-classrooms-signup__table-cell --signup-button"></div>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'DigitalClassRoomTable',
        props: {
            pastEventsTable: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    @include digital-classrooms-table;
    .digital-classrooms-signup {
        &__table {
            display: flex;
            flex-direction: column;
            border: solid 1px $alto;
            overflow: hidden;
            border-radius: 10px;
        }
        &__headers {
            color: $tuatara;
            background: $wild_sand;
            border-bottom: 1px solid $alto;
            min-height: 60px;
            font-size: 1.6rem;

            &.--mobile {
                background: $white !important;
                margin: 5px 0;
            }
        }
    }
</style>
